<app-monitoring-tickets-osm-map
  [tickets]="tickets"
  [ticketsMultipleAssign]="ticketsMultipleAssign"
></app-monitoring-tickets-osm-map>
